module.exports = __webpack_public_path__ + "img/ottbox.39eb3ecd.jpeg";